import React, { useEffect } from "react";
import FileUploadField from "../CommonComponents/FileUploadField";

export default function ProfileSection({ profile, profilePreview, onChange, onPicChange, setProfile, handleSaveProfile, isSavingProfile }) {
  useEffect(() => {
    async function fetchUser() {
      try {
        const { default: axiosInstance } = await import("../../services/axiosInstance");
        const { getCurrentUser } = await import("../../utils/authStorage");
        const user = getCurrentUser();
        if (user && user.id) {
          // Fetch user info from backend
          const res = await axiosInstance.get(`/admin/users/${user.id}`);
          const data = res.data?.data || res.data;
          setProfile(prev => ({
            ...prev,
            firstName: data.first_name || data.firstName || "",
            lastName: data.last_name || data.lastName || "",
            email: data.email || "",
            phone: data.phone || "",
            picture: data.picture || data.image || null,
            username: data.username || "",
            role_id: data.role_id || null,
            branch_id: data.branch_id || null
          }));
        }
      } catch (e) {
        // Optionally handle error
      }
    }
    fetchUser();
    // Only run on mount
    // eslint-disable-next-line
  }, [setProfile]);
  return (
    <div className="flex flex-col gap-3 px-5 pb-5">
      <input type="text" name="firstName" placeholder="First Name" className="bg-[#f6f6f8] border-none rounded-xl px-4 py-3 text-base" value={profile.firstName || ""} onChange={onChange} />
      <input type="text" name="lastName" placeholder="Last Name" className="bg-[#f6f6f8] border-none rounded-xl px-4 py-3 text-base" value={profile.lastName || ""} onChange={onChange} />
      <input type="email" name="email" placeholder="Email" className="bg-[#f6f6f8] border-none rounded-xl px-4 py-3 text-base" value={profile.email} onChange={onChange} />
      <input type="tel" name="phone" placeholder="Phone" className="bg-[#f6f6f8] border-none rounded-xl px-4 py-3 text-base" value={profile.phone} onChange={onChange} />
      {/* Hidden fields for required backend values */}
      <input type="hidden" name="username" value={profile.username || ""} />
      <input type="hidden" name="role_id" value={profile.role_id || ""} />
      <input type="hidden" name="branch_id" value={profile.branch_id || ""} />
      <FileUploadField
        label="Profile Picture"
        accept="image/*"
        value={profile.picture}
        preview={profilePreview || profile.picture}
        onChange={onPicChange}
        onRemove={() => onPicChange(null)}
        optional={true}
      />
      <button
        type="button"
        className="mt-2 px-5 py-2 bg-[#f1f1f4] text-gray-700 rounded-xl hover:bg-blue-50 border border-gray-200 text-base font-medium transition disabled:opacity-60 disabled:cursor-not-allowed"
        onClick={handleSaveProfile}
        disabled={isSavingProfile}
      >
        {isSavingProfile ? "Saving..." : "Save Profile"}
      </button>
    </div>
  );
}
